import { CreditCardType, ReduxAction } from '../../enums/const-enums';

export interface CardState {
  accountNumber?: string;
  cardNumber: string;
  creditCardType?: CreditCardType;
  creditCardSuffix?: string;
  isCardRemembered?: boolean;
  isCardSwitchAllowed: boolean;
  isCardValid: boolean;
}

const initialState: CardState = {
  accountNumber: '',
  cardNumber: '',
  creditCardType: null,
  creditCardSuffix: '',
  isCardRemembered: false,
  isCardSwitchAllowed: true,
  isCardValid: false,
};

export interface ChallengeAction {
  type: ReduxAction;
  payload: CardState;
}

export function cardReducer(
  state: CardState = initialState,
  action: ChallengeAction,
): CardState {
  switch (action.type) {
    case ReduxAction.SET_ACCOUNT_NUMBER:
      state.accountNumber = action.payload.accountNumber;
      break;
    case ReduxAction.SET_CARD_NUMBER:
      state.cardNumber = action.payload.cardNumber;
      break;
    case ReduxAction.SET_IS_CARD_REMEMBERED:
      state.isCardRemembered = action.payload.isCardRemembered;
      break;
    case ReduxAction.SET_IS_CARD_SWITCH_ALLOWED:
      state.isCardSwitchAllowed = action.payload.isCardSwitchAllowed;
      break;
    case ReduxAction.SET_IS_CARD_VALID:
      state.isCardValid = action.payload.isCardValid;
      break;
    case ReduxAction.SET_DEBIT_CARD:
      state.accountNumber = action.payload.accountNumber;
      state.cardNumber = action.payload.cardNumber;
      state.isCardRemembered = action.payload.isCardRemembered;
      state.isCardSwitchAllowed = action.payload.isCardSwitchAllowed;
      state.isCardValid = action.payload.isCardValid;
      break;
    case ReduxAction.SET_CREDIT_CARD:
      state.cardNumber = action.payload.cardNumber;
      state.isCardValid = action.payload.isCardValid;
      state.creditCardType = action.payload.creditCardType;
      state.isCardSwitchAllowed = action.payload.isCardSwitchAllowed;
      state.creditCardSuffix = action.payload.creditCardSuffix;
      break;
  }
  return state;
}
